export default "__VITE_ASSET__Cf1hs5Y4__"